import { IError } from "types/api";
import envirement from "../envirement";

export const subscribedEvents: Array<string> = [
  "mousemove",
  "keydown",
  "wheel",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "MSPointerDown",
  "MSPointerMove",
];

export const API_BASE_URL = process.env.REACT_APP_API_URL

export const APP_AUTH_ENABLE = true;

export const APP_NOTIFICATION_MAX_STACK = 1;

export const APP_NOTIFICATION_VERTICAL = 'top'; // top | bottom

export const APP_NOTIFICATION_HORIZONTAL = 'center'; // left | center | right

export const APP_VALIDATE_SKIP_WARD = false;

export const MAX_LENGTH_INPUT = 2000;

export const APP_SESSION_TIMEOUT = 900000; // 15 minutes

export const APP_TOKEN_NAME = 'accessToken';

export const APP_REFRESH_TOKEN_NAME = 'refreshToken';

export const APP_USER_NAME = 'userName';

export const APP_USER_EMAIL = 'email';
export const APP_ACTIVE_USER = 'active';

export const APP_USER_ROLE = 'role';
export const APP_USER_DEPARTMENT = 'department';
export const APP_USER_PERMISSION = 'permission';

export const SUPER_ADMIN_ROLE = 'super-admin';
export const USER_ROLE = 'user';
export const ADMIN_ROLE = 'admin';

export const ON_FETCH_ERROR = [
  {
    detail: 'Cannot send request.',
    msg: 'ERR_CANNOT_SEND_REQUEST',
    loc: 'FETCH',
  },
] as IError[];

export const ON_FETCH_ERROR_MSG = [
  {
    detail: 'Thông tin đăng nhập không hợp lệ',
    msg: 'ERR_CANNOT_SEND_REQUEST',
    loc: 'FETCH',
  },
] as IError[];

export const ON_RESPONSE_ERROR = [
  {
    loc: 'RESPONSE',
    msg: 'Result_Response_failure',
    detail: 'Result response failure',
  },
] as IError[];

export const ON_PARSE_ERROR = [
  {
    loc: 'PARSE',
    msg: 'Parse_Response_failure',
    detail: 'Parse response failure',
  },
] as IError[];

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_DATETIME_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_TIMESTAMP_FORMAT = 'HH:mm A, DD/MM/YYYY';
export const APP_TIMESTAMP_FORMAT_DOCS = 'DD/MM/YYYY, HH:mm A';
export const APP_TIMESTAMP_PLACEHOLDER = 'HH:mm AM, DD/MM/YYYY';
export const APP_TIMESTAMP_FORMAT_CUSTOM = 'HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATE_FORMAT_LOWER_CASE = 'dd/mm/yyyy';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_NOTIFY = 'YYYY-MM-DD';
export const APP_LOCAL_DATETIME_FORMAT_NOTIFY_NEW = 'YYYY-MM-DD HH:mm:ss';
export const APP_LOCAL_FORMAT_QUESTION_SAMPLE = 'hh:mm A, DD/MM/YYYY';
export const APP_LOCAL_FORMAT_CHATBOT_HISTORICAL = 'DD-MM-YYYY hh:mm A';
export const APP_LOCAL_FORMAT_QUESTION_SAMPLE_FULL = 'HH:mm:ss A, MM/DD/YYYY';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
export const APP_LOCAL_DATETIME_FORMAT_DATEFORM = 'YYYY-MM-DD 00:00:00';
export const APP_LOCAL_DATETIME_FORMAT_DATETO = 'YYYY-MM-DD 23:59:59';
export const APP_DEFAULT_PAGE_SIZE = 10;
export const APP_PAGE_SIZES = [10, 20, 30, 40, 50];
export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@(fpt|lge|lgepartner)\.com$/;
export const REGEX_SPACE = /\s/g;

export const FORMAT_DATETIME = {
  NO_TIME: 'YYYY-MM-DD 00:00:00',
};
